// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { StockManagementSubscriptions } from '../../../../types/server/modules/stockManagement/subscriptions';

export type * from '../../../../types/server/modules/stockManagement/subscriptions';

export const createSubscriptions = ( requests: Requests ): StockManagementSubscriptions => ({
  StockManagementWarehouses: ( params, onChange ) => {
          return requests.subscribe( `/stock-management/warehouses/:id?`, params, 'StockManagementWarehouses', onChange );
          },
  StockManagementShortfalls: ( params, onChange ) => {
          return requests.subscribe( `/stock-management/shortfalls/:id?`, params, 'StockManagementShortfalls', onChange );
          },
  StockManagementMovementsByOrder: ( params, onChange ) => {
          return requests.subscribe( `/stock-management/movements-by-order/:id?`, params, 'StockManagementMovementsByOrder', onChange );
          }
});
